import { createSelector, createSlice } from '@reduxjs/toolkit'
import { SettingsState } from './types'
import { RootState } from '../../../store/rootReducer'

export const initialState: SettingsState = {
  local: {
    dashboardHelperMessageOpen: undefined,
  },
}

const SettingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setDashboardHelperMessageOpen: (state, action) => {
      state.local.dashboardHelperMessageOpen = action.payload
    },
  },
})

const selectState = (state: RootState) => state

export const selectDasboardHelperMessageOpen = createSelector(selectState, (state) => {
  return state.settings.local.dashboardHelperMessageOpen
})

export default SettingsSlice
export type { SettingsState } from './types'
